import styled from "styled-components";

export const FolderDetailMenuWrapper = styled.div`
    display: flex;

    & > div.folder-detail-menu > div > div > div > div {
        max-height: max-content;
    }
    
    & > div.folder-detail-menu > div > div > div > div > div:nth-child(2),
    & > div.folder-detail-menu > div > div > div > div > div:nth-child(6){
        border-bottom: 1px solid ${(props) => props.theme.colors.clearGray};
    }
`